import React from 'react'
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <div className={styles.footer}>
      <p>@2023 PRO7ON</p>
    </div>
  )
}

export default Footer
